module.exports = __webpack_public_path__ + "static/img/20005 (5).e160a8d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20005 (5).webp
// module id = UOF+
// module chunks = 14